<fgb-banner [pageTitle]="'subscriptions.page.title' | translate" />
<fgb-account-nav></fgb-account-nav>
<fgb-subscriptions-list></fgb-subscriptions-list>
